<!--
  创建时间：2023/7/27 16:19
  创建人：toyehuang
  文件描述：head 页面头部布局
-->
<template>
  <header class="layout-head">
    <div class="layout_header_top def-w f-b-c fc99">
      <div class="top-left f-b-c">
        <span>{{ site.name }}欢迎您！</span>
      </div>
      <div class="top-right">
        <span class="online-service" @click="openCustomerService">
          <i class="el-icon-service"></i>AI客服
        </span>
        咨询电话：<span class="fc33">{{ site.consultHotline }}</span>
        （工作时间：{{ site.workTime }}）
      </div>
    </div>
    <div class="layout_head_container">
      <div class="def-w f-b-c">
        <a href="/" :title="site.name">
          <img :src="headerLogo" :alt="site.name">
        </a>
        <head-search />
      </div>
    </div>
    <head-nav v-if="!$route.meta.hideNav" />
  </header>
</template>

<script>
import HeadSearch from "@/layout/components/LayoutHead/HeadSearch.vue";
import HeadNav from "@/layout/components/LayoutHead/HeadNav/index.vue";
import { mapGetters } from "vuex";
import { openCustomerService } from "@/utils/customerService";
const nx_logo = require("@/assets/images/nx_logo.png");
export default {
  name: "LayoutHead",
  components: { HeadNav, HeadSearch },
  props: {
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["site"]),
    headerLogo() {
      const infoid = this.$route.query.infoid || ""
      return infoid.indexOf("nxzc_") === 0
        ? nx_logo
        : this.site.logo
    },
    registerUrl() {
      return process.env.VUE_APP_REGISTER_LINK
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 唤醒七陌在线客服
    openCustomerService
  }
};
</script>

<style scoped lang="scss">
.layout-head{
  width: 100%;
  background-color: #f5f5f5;
  //border-bottom: 2px solid $--color-primary;
  //&.no-border{
  //  border-bottom: none;
  //}
  .layout_header_top{
    height: 40px;
    .top-left{
      .button-group{
        white-space: nowrap;
      }
    }
    .top-right{
      .online-service{
        display: inline-block;
        margin-right: 10px;
        padding: 0 8px;
        line-height: 20px;
        border: 1px solid $--color-primary;
        border-radius: 2px;
        font-size: 12px;
        color: $--color-primary;
        cursor: pointer;
        user-select: none;
        transition: all .2s;
        i{
          margin-right: 2px;
        }
        &:hover{
          color: #fff;
          background-color: $--color-primary;
        }
      }
    }
  }
  .layout_head_container{
    //background: url("@/assets/images/head_bg.png") no-repeat center / cover;
		background-color: #fff;
    .def-w{
      height: 100px;
    }
  }
}
</style>
